import { Pipe, PipeTransform } from '@angular/core';
import { isArray } from 'lodash';

@Pipe({ name: 'arrayValue' })
export class ArrayValuePipe implements PipeTransform {
	transform(
		value: string | Array<string | { [key: string]: any }>,
		property?: string | Array<string>,
		postfix: string = ''
	): string {
		if (isArray(value)) {
			if (property) {
				if (value) {
					if (isArray(property)) {
						return (value as Array<string | { [key: string]: any }>)
							.map((value) => `${value[property[0]]} ${value[property[1]]}${postfix}`)
							.join(', ');
					}
					return (value as Array<string | { [key: string]: any }>)
						.map((value) => `${value[property as string]}${postfix}`)
						.join(', ');
				} else return '';
			} else if (!value) {
				return '';
			} else
				return (value as Array<string | { [key: string]: any }>)
					.map((_value) => `${_value}${postfix}`)
					.join(', ');
		}
		return value ? (value as string) : '';
	}
}
